module.exports = __webpack_public_path__ + "img/arrow-up.97737d57.svg";